var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRt5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff1",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M138 62L138 63L297 63C284.593 57.7937 262.515 62 249 62L138 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M133 63L134 64L133 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M114 166C93.7612 158.204 66.118 163.476 65.0401 190C64.6465 199.686 72.5429 205.687 73.1304 214C73.5838 220.415 65.3014 228.279 65.0432 236C64.7366 245.17 73.0247 252.22 73.0247 260C73.0247 267.084 65.1345 273.802 65.0185 282C64.884 291.505 72.4303 296.937 73.3873 305C73.8323 308.749 68.8121 313.584 67.338 317C64.3608 323.899 64.1742 331.995 66.9267 339C74.8251 359.101 96.3593 360.795 114 354C114 373.66 108.446 403.945 133 411.215C143.43 414.304 157.544 409.409 167 414.024C173.1 417.001 178.132 422.811 184 426.385C196.697 434.118 210.569 439.042 225 442.349C232.468 444.06 244.27 443.272 250.816 447.027C254.917 449.38 256.591 454.681 260.174 457.682C262.765 459.852 266.727 460.704 269.485 458.258C275.999 452.481 263.912 437.89 258.96 434.603C251.932 429.939 237.364 431.149 229 429.338C214.589 426.217 202.698 418.335 189 414L189 413L280 413C293.351 413 308.998 413.14 316.637 400C324.876 385.827 321 363.766 321 348L321 229C321 216.983 318.057 200.514 321.514 189C325.356 176.201 343.554 165.684 356 164C356 197.508 355.623 231.592 357.91 265C358.474 273.233 356.968 281.837 358.213 290C359.254 296.827 364.033 303.656 366.716 310C370.781 319.614 373.712 329.857 376.116 340C378.443 349.821 379.875 359.964 380.83 370C381.332 375.276 380.176 381.014 382.43 386C385.797 393.45 393.41 399.888 398.718 406C410.562 419.637 422.223 433.44 434.155 447C437.855 451.205 450.781 467.964 455.214 454.956C457.524 448.176 445.675 438.556 441.718 434C431.007 421.667 420.196 409.414 409.579 397C405.17 391.844 398.486 386.316 395.854 380C390.48 367.103 392.144 348.892 388.989 335C385.137 318.039 374.964 302.53 371.39 286C367.417 267.62 370.866 244.873 370.039 226C369.259 208.178 371.899 189.697 369.576 172C368.933 167.102 370.178 160.329 367.258 156.108C356.595 140.699 329.77 158.613 321 167L321 103C321 91.9846 321.559 79.8742 313.671 71.0934C303.196 59.432 284.021 63 270 63L163 63C148.566 63 130.786 59.6581 120.329 72.0154C112.868 80.8332 114 92.2273 114 103L114 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M300 63L301 64L300 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M301 63L302 64L301 63M130 64L131 65L130 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M303 64L304 65L303 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M304 64L305 65L304 64M128 65L129 66L128 65M306 65L307 66L306 65M126 66L127 67L126 66M309 67L310 68L309 67M122 69L123 70L122 69M121 70L122 71L121 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M120 71L121 72L120 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M315 73L316 74L315 73M118 74L119 75L118 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M316 74L317 75L316 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M138.667 76.3333L139.333 76.6667L138.667 76.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M140 76L140 77L295 77C283.068 71.9933 261.991 76 249 76L140 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M295.667 76.3333L296.333 76.6667L295.667 76.3333M317 76L318 77L317 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M116 77L117 78L116 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M135 77L136 78L135 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff1",
      stroke: "none"
    },
    d: "M128 93C141.839 87.6705 158.333 90 173 90L260 90C276.065 90 293.191 86.9908 307 96C306.938 73.4256 289.276 77 272 77L167 77C151.622 77 128.18 71.5244 128 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M299 77L300 78L299 77M133 78L134 79L133 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M301 78L302 79L301 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M318 78L319 79L318 78M302 79L303 80L302 79M115 80L116 81L115 80M303 80L304 81L303 80M130 81L131 82L130 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M304 81L305 82L304 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M319 81L320 82L319 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M129 82L130 83L129 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M114.333 83.6667L114.667 84.3333L114.333 83.6667M305 83L306 84L305 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M128 84L129 85L128 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M320 84L321 85L320 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M128 85L129 86L128 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M306 85L307 86L306 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M320 85L320 88L321 88L320 85M306 86L307 87L306 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M306 87L307 88L306 87M134.005 90.5332C123.423 93.1544 128 119.243 128 128L128 246L128 351C128 362.229 124.005 383.136 130.09 392.906C136.54 403.263 159.623 399 170 399L256 399C268.615 399 284.865 401.706 297 398.057C311.717 393.631 307 369.729 307 358L307 232L307 133C307 123.628 310.868 102.907 305.397 95.1049C298.642 85.474 274.351 90 264 90L176 90C162.942 90 146.692 87.3905 134.005 90.5332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M193 98L193 99L218 99L193 98M236 98L236 99L241 99L236 98M191 99L192 100L191 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M192.109 99.7423C187.13 101.883 187.131 109.117 192.109 111.258C197.328 113.503 214.886 113.809 219.772 110.821C224.042 108.209 223.398 101.681 218.891 99.7423C213.505 97.4258 197.495 97.4258 192.109 99.7423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M219 99L220 100L219 99M233 99L231 102L233 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M234.148 100.028C225.895 104.91 235.473 115.236 242.866 110.972C251.446 106.024 241.621 95.6066 234.148 100.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M243 99L244 100L243 99M244 100L245 101L244 100M245 101L246 102L245 101M188 102L189 103L188 102M222 102L223 103L222 102M246.333 103.667L246.667 104.333L246.333 103.667M230 104L230 107L231 107L230 104M223 105L224 106L223 105M246.333 106.667L246.667 107.333L246.333 106.667M188 108L189 109L188 108M222 108L223 109L222 108M245 109L246 110L245 109M232 110L233 111L232 110M244 110L245 111L244 110M191 111L192 112L191 111M219 111L220 112L219 111M234 111L235 112L234 111M243 111L244 112L243 111M194 112L194 113L217 113L194 112M236 112L236 113L241 113L236 112M214 143L214 144L221 144L214 143M209.667 144.333L210.333 144.667L209.667 144.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M187 179C180.885 179 169.127 176.74 164.434 181.434C160.006 185.861 162 196.275 162 202L162 258C162 267.918 156.905 294.073 171 294.956C195.788 296.509 221.158 295 246 295C252.518 295 266.692 297.651 271.142 291.721C275.353 286.11 273 273.67 273 267L273 206C273 199.444 275.199 187.803 271.142 182.228C266.992 176.527 254.201 179 248 179C247.999 168.982 246.367 159.625 238.816 152.301C224.477 138.394 199.605 142.479 190.327 160C187.095 166.103 187 172.275 187 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M224.667 144.333L225.333 144.667L224.667 144.333M206 145L207 146L206 145M227.667 145.333L228.333 145.667L227.667 145.333M204 146L205 147L204 146M230 146L231 147L230 146M202 147L203 148L202 147M232 147L233 148L232 147M200 148L201 149L200 148M199 149L200 150L199 149M235 149L236 150L235 149M236 150L237 151L236 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M351 150L352 151L351 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M352 150L352 151L357 151L352 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M357 150L358 151L357 150M346 151L347 152L346 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M347 151L348 152L347 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M360 151L361 152L360 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M361 151L362 152L361 151M343 152L344 153L343 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M344 152L345 153L344 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M363 152L364 153L363 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M341 153L342 154L341 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M338 154L339 155L338 154M241 155L242 156L241 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M336 155L337 156L336 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M192 156L193 157L192 156M242 156L243 157L242 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M334 156L335 157L334 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M191 157L192 158L191 157M215 157L215 158L220 158L215 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M333 157L334 158L333 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M368 157L369 158L368 157M211 158L212 159L211 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M201 179L234 179C233.989 162.489 214.218 147.427 203.009 166.004C200.618 169.967 201 174.556 201 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M222.667 158.333L223.333 158.667L222.667 158.333M243 158L244 159L243 158M331 158L332 159L331 158M190 159L191 160L190 159M209 159L210 160L209 159M225 159L226 160L225 159M244 159L245 160L244 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M369 159L370 160L369 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M207 160L208 161L207 160M328 160L329 161L328 160M369 160L369 171L370 171L369 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M92 161L92 162L100 162L92 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M189 161L190 162L189 161M206 161L207 162L206 161M228 161L229 162L228 161M245 161L246 162L245 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M327 161L328 162L327 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M87 162L88 163L87 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M88 162L89 163L88 162M103 162L104 163L103 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M104 162L105 163L104 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M105 162L106 163L105 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M205 162L206 163L205 162M229 162L230 163L229 162M84 163L85 164L84 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M107 163L108 164L107 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M108 163L109 164L108 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M188 163L189 164L188 163M204 163L205 164L204 163M324 163L325 164L324 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M82 164L83 165L82 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M110 164L111 165L110 164M203 164L204 165L203 164M246 164L247 165L246 164M323 164L324 165L323 164M352 164L352 165L355 165L355 170L356 170L356 164L352 164M112 165L113 166L112 165M231 165L232 166L231 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M322 165L323 166L322 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M348.667 165.333L349.333 165.667L348.667 165.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M190 413L190 414C203.263 420.979 216.243 426.431 231 429.4C238.985 431.006 250.914 429.974 257.961 433.988C266.449 438.824 273.827 451.213 269 460L445 460L399.87 407L382.318 386L379.911 366L375.349 338L357.329 288L357 248L355 165C342.692 165.562 324.811 176.43 321.433 189C318.569 199.658 321 213.971 321 225L321 345C321 360.361 325.178 383.024 318.19 397C310.289 412.801 295.451 413 280 413L190 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M78 166L79 167L78 166M187.333 166.667L187.667 167.333L187.333 166.667M202 166L203 167L202 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M321 166L322 167L321 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M346 166L347 167L346 166M247.333 167.667L247.667 168.333L247.333 167.667M343 167L344 168L343 167M75 168L76 169L75 168M201 168L202 169L201 168M341 168L342 169L341 168M74 169L75 170L74 169M233 169L234 170L233 169M340 169L341 170L340 169M73 170L74 171L73 170M338 170L339 171L338 170M72 171L73 172L72 171M186 171L186 179L187 179L186 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M369 171L370 172L369 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M71 172L72 173L71 172M200 172L200 179L201 179L200 172M335 172L336 173L335 172M334 173L335 174L334 173M333 174L334 175L333 174M69 175L70 176L69 175M93 175L93 176L99 176L93 175M89.6667 176.333L90.3333 176.667L89.6667 176.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M91 176.533C68.9967 181.882 81.2228 211.895 102 206.442C123.489 200.803 111.487 171.553 91 176.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M102.667 176.333L103.333 176.667L102.667 176.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M68 177L69 178L68 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M87 177L88 178L87 177M105 177L106 178L105 177M85 178L86 179L85 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M67 179L68 180L67 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M84 179L85 180L84 179M108 179L109 180L108 179M166 179L167 180L166 179M268 179L269 180L268 179M83 180L84 181L83 180M109 180L110 181L109 180M164 180L165 181L164 180M270 180L271 181L270 180M66 181L67 182L66 181M82 181L83 182L82 181M163 181L164 182L163 181M81 182L82 183L81 182M162.333 182.667L162.667 183.333L162.333 182.667M325 182L326 183L325 182M111 183L112 184L111 183M272.333 183.667L272.667 184.333L272.333 183.667M324 183L325 184L324 183M65.3333 184.667L65.6667 185.333L65.3333 184.667M80 184L81 185L80 184M323 184L324 185L323 184M112 185L113 186L112 185M79.3333 186.667L79.6667 187.333L79.3333 186.667M113 187L113 190L114 190L113 187M321 187L322 188L321 187M78 191L79 192L78 191M113 193L113 196L114 196L113 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M176 193L176 281L259 281L259 193L248 193C248 197.014 248.845 202.181 247.397 205.985C245.122 211.959 238.231 212.668 235.179 206.956C233.071 203.01 234 197.329 234 193L201 193C201 197.715 201.913 203.764 199.142 207.891C195.191 213.776 188.338 211.065 186.573 204.996C185.479 201.239 186 196.872 186 193L176 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M186 193L186 206L187 206L186 193M200 193L200 206L201 206L200 193M79.3333 195.667L79.6667 196.333L79.3333 195.667M65.3333 197.667L65.6667 198.333L65.3333 197.667M112 197L113 198L112 197M80 198L81 199L80 198M111 199L112 200L111 199M356 199L356 229L357 229L356 199M81 200L82 201L81 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M370 200L370 215L371 215L370 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M66 201L67 202L66 201M82 201L83 202L82 201M83 202L84 203L83 202M109 202L110 203L109 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M67 203L68 204L67 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M84 203L85 204L84 203M85 204L86 205L85 204M106 204L107 205L106 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M68 205L69 206L68 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M87 205L88 206L87 205M105 205L106 206L105 205M234.333 205.667L234.667 206.333L234.333 205.667M89 206L90 207L89 206M102 206L103 207L102 206M69 207L70 208L69 207M247 207L248 208L247 207M187 208L188 209L187 208M199 208L200 209L199 208M235 208L236 209L235 208M188 209L189 210L188 209M198 209L199 210L198 209M236 209L237 210L236 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M71 210L72 211L71 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M189 210L190 211L189 210M197 210L198 211L197 210M237 210L238 211L237 210M244 210L245 211L244 210M72 211L73 212L72 211M191 211L191 212L196 212L191 211M239 211L239 212L243 212L239 211M73 212L74 213L73 212M74 213L75 214L74 213M370 215L370 231L371 231L370 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M72 217L73 218L72 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M71 218L72 219L71 218M70 219L71 220L70 219M91 221L91 222L102 222L91 221M68 222L69 223L68 222M88 222L89 223L88 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M89.0008 222.653C68.0492 229.254 83.2292 258.588 102.999 251.751C124.677 244.254 109.22 216.282 89.0008 222.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M103.667 222.333L104.333 222.667L103.667 222.333M86 223L87 224L86 223M67 224L68 225L67 224M107 224L108 225L107 224M108 225L109 226L108 225M109 226L110 227L109 226M66 227L67 228L66 227M110 227L111 228L110 227M81 228L82 229L81 228M111 228L112 229L111 228M65 230L66 231L65 230M112 230L113 231L112 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M65 231L66 232L65 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M79 232L80 233L79 232M113 233L113 236L114 236L113 233M113 238L113 241L114 241L113 238M79.3333 241.667L79.6667 242.333L79.3333 241.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M65 242L66 243L65 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M65 243L66 244L65 243M112 243L113 244L112 243M80 244L81 245L80 244M111 245L112 246L111 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M66 246L67 247L66 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M110 246L111 247L110 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M66 247L67 248L66 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M82 247L83 248L82 247M83 248L84 249L83 248M67 249L68 250L67 249M107 249L108 250L107 249M86 250L87 251L86 250M106 250L107 251L106 250M68 251L69 252L68 251M88 251L89 252L88 251M104 251L105 252L104 251M90 252L90 253L93 253L90 252M100.667 252.333L101.333 252.667L100.667 252.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M69 253L70 254L69 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M70 254L71 255L70 254M357 261L357 290L358 290L357 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M371 263L371 279L372 279L371 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M70 265L71 266L70 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M69 266L70 267L69 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M90.6667 267.333L91.3333 267.667L90.6667 267.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M92 267.479C69.1594 272.186 80.1001 302.639 102 297.606C122.896 292.803 112.009 263.356 92 267.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M101.667 267.333L102.333 267.667L101.667 267.333M68 268L69 269L68 268M87 268L88 269L87 268M104 268L105 269L104 268M86 269L87 270L86 269M106 269L107 270L106 269M67 270L68 271L67 270M84 270L85 271L84 270M83 271L84 272L83 271M66 272L67 273L66 272M82 272L83 273L82 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M66 273L67 274L66 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M110 273L111 274L110 273M111 274L112 275L111 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M65 275L66 276L65 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M80 275L81 276L80 275M65 276L66 277L65 276M112 276L113 277L112 276M79.3333 277.667L79.6667 278.333L79.3333 277.667M113 279L113 282L114 282L113 279M371 279L371 287L372 287L371 279M78 282L79 283L78 282M113 284L113 287L114 287L113 284M79 287L80 288L79 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M371 287L372 288L371 287M65 288L66 289L65 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M112.333 288.667L112.667 289.333L112.333 288.667M65 289L66 290L65 289M80 289L81 290L80 289M272.333 289.667L272.667 290.333L272.333 289.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M372 289L373 290L372 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M111 290L112 291L111 290M162 290L163 291L162 290M81 291L82 292L81 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M373 291L374 292L373 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M66 292L67 293L66 292M110 292L111 293L110 292M163 292L164 293L163 292M358 292L359 293L358 292M109 293L110 294L109 293M164 293L165 294L164 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M374 293L375 294L374 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M108 294L109 295L108 294M166 294L167 295L166 294M267.667 294.333L268.333 294.667L267.667 294.333M359 294L360 295L359 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M67 295L68 296L67 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M107 295L108 296L107 295M375 295L376 296L375 295M86 296L87 297L86 296M105 296L106 297L105 296M360 296L361 297L360 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M68 297L69 298L68 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M88.6667 297.333L89.3333 297.667L88.6667 297.333M103 297L104 298L103 297M376 297L377 298L376 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M69 298L70 299L69 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M91 298L91 299L101 299L91 298M361 298L362 299L361 298M377 299L378 300L377 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M70 300L71 301L70 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M362 300L363 301L362 300M71 301L72 302L71 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M72 302L73 303L72 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M363 302L364 303L363 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M378 302L379 303L378 302M73 303L74 304L73 303M74 304L75 305L74 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M364 304L365 305L364 304M379 304L380 305L379 304M74 306L75 307L74 306M191 306L191 307L244 307L227 306L191 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M380 306L381 307L380 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M73 307L74 308L73 307M188 307L186 310L188 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M189.109 308.028C184.281 310.75 184.645 317.907 190.105 319.566C202.033 323.191 219.525 320 232 320C236.199 320 243.227 321.309 246.682 318.397C251.264 314.534 248.123 308.181 242.995 307.228C230.802 304.964 216.406 307 204 307C199.628 307 193.049 305.806 189.109 308.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M245 307L246 308L245 307M365 307L366 308L365 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M380 307L381 308L380 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M72 308L73 309L72 308M247 308L248 309L247 308M71 309L72 310L71 309M366 309L367 310L366 309M381 309L382 310L381 309M185 311L186 312L185 311M367.333 311.667L367.667 312.333L367.333 311.667M69 312L70 313L69 312M93 312L93 313L100 313L93 312M249 312L249 316L250 316L249 312M382 312L383 313L382 312M89 313L90 314L89 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M90.0008 313.649C68.4493 320.182 82.6393 350.044 103 343.146C124.105 335.996 109.936 307.606 90.0008 313.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M102.667 313.333L103.333 313.667L102.667 313.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M68 314L69 315L68 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M87 314L88 315L87 314M105 314L106 315L105 314M368 314L369 315L368 314M85 315L86 316L85 315M185.333 315.667L185.667 316.333L185.333 315.667M383 315L384 316L383 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M67 316L68 317L67 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M84 316L85 317L84 316M108 316L109 317L108 316M109 317L110 318L109 317M186 317L187 318L186 317M248 317L249 318L248 317M369 317L370 318L369 317M66 318L67 319L66 318M82 318L83 319L82 318M110 318L111 319L110 318M247 318L248 319L247 318M384 318L385 319L384 318M81 319L82 320L81 319M188 319L189 320L188 319M246 319L247 320L246 319M111 320L112 321L111 320M190 320L190 321L244 321L226 320L190 320M370 320L371 321L370 320M65.3333 321.667L65.6667 322.333L65.3333 321.667M80 321L81 322L80 321M385 321L386 322L385 321M112 322L113 323L112 322M79.3333 323.667L79.6667 324.333L79.3333 323.667M371 323L372 324L371 323M113 324L113 327L114 327L113 324M386 324L387 325L386 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M386 325L387 326L386 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M372.333 326.667L372.667 327.333L372.333 326.667M78 328L79 329L78 328M387 328L388 329L387 328M373.333 329.667L373.667 330.333L373.333 329.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M387 329L388 330L387 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M113 330L113 333L114 333L113 330M388.333 331.667L388.667 332.333L388.333 331.667M79.3333 332.667L79.6667 333.333L79.3333 332.667M180 333L180 334L254 334L231 333L180 333M374.333 333.667L374.667 334.333L374.333 333.667M65.3333 334.667L65.6667 335.333L65.3333 334.667M112 334L113 335L112 334M177 334L178 335L177 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3b3f",
      stroke: "none"
    },
    d: "M178 334.529C158.379 339.065 156.849 367.004 174.001 375.622C181.246 379.262 190.137 378 198 378C215.816 378 239.964 382.246 257 376.945C276.471 370.887 277.695 343.435 259 335.367C252.07 332.377 242.41 334 235 334C217.219 334 195.319 330.526 178 334.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M257 334L258 335L257 334M80 335L81 336L80 335M174 335L175 336L174 335M259 335L260 336L259 335M111 336L112 337L111 336M172 336L173 337L172 336M261 336L262 337L261 336M389 336L390 337L389 336M81 337L82 338L81 337M263 337L264 338L263 337M375.333 337.667L375.667 338.333L375.333 337.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M389 337L390 338L389 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M66 338L67 339L66 338M82 338L83 339L82 338M264 338L265 339L264 338M83 339L84 340L83 339M109 339L110 340L109 339M168 339L169 340L168 339M265 339L266 340L265 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M67 340L68 341L67 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M84 340L85 341L84 340M167 340L168 341L167 340M266 340L267 341L266 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M390 340L391 341L390 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M85 341L86 342L85 341M106 341L107 342L106 341M267 341L268 342L267 341M376 341L376 344L377 344L376 341M390 341L391 342L390 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M68 342L69 343L68 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M87 342L88 343L87 342M105 342L106 343L105 342M268 342L269 343L268 342M89.6667 343.333L90.3333 343.667L89.6667 343.333M102 343L103 344L102 343M69 344L70 345L69 344M94 344L94 345L98 345L94 344M164 344L165 345L164 344M269 344L270 345L269 344M270 345L271 346L270 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M391 345L392 346L391 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M163 346L164 347L163 346M377 346L377 349L378 349L377 346M391.333 346.667L391.667 347.333L391.333 346.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M182.015 347.573C173.382 350.125 174.086 360.997 182.005 363.968C196.665 369.467 220.383 365 236 365C241.915 365 249.593 366.104 254.891 362.86C262.018 358.497 258.385 348.581 250.999 347.228C236.925 344.65 220.317 347 206 347C198.589 347 189.163 345.459 182.015 347.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M72 348L73 349L72 348M271 348L272 349L271 348M73 349L74 350L73 349M162 349L163 350L162 349M74 350L75 351L74 350M272.333 351.667L272.667 352.333L272.333 351.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M392 351L393 352L392 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M378 352L378 355L379 355L378 352M392.333 352.667L392.667 353.333L392.333 352.667M78 353L79 354L78 353M161 353L161 359L162 359L161 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M80 354L81 355L80 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M112 354L113 355L112 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M82 355L83 356L82 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M110 355L111 356L110 355M84 356L85 357L84 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M85 356L86 357L85 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M107 356L108 357L107 356M87.6667 357.333L88.3333 357.667L87.6667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M103 357L104 358L103 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M104 357L105 358L104 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M94 358L94 359L98 359L94 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M272 358L272 361L273 361L272 358M379 358L379 363L380 363L379 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M393 358L394 359L393 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M393 359L393 362L394 362L393 359M162.333 361.667L162.667 362.333L162.333 361.667M271 363L272 364L271 363M163 364L164 365L163 364M270 365L271 366L270 365M164 366L165 367L164 366M269 367L270 368L269 367M380 367L380 374L381 374L380 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M394.333 367.667L394.667 368.333L394.333 367.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M165 368L166 369L165 368M166 369L167 370L166 369M394 369L394 374L395 374L394 369M266 371L267 372L266 371M170 373L171 374L170 373M171 374L172 375L171 374M262 374L263 375L262 374M173 375L174 376L173 375M175 376L176 377L175 376M258 376L259 377L258 376M178 377L179 378L178 377M255.667 377.333L256.333 377.667L255.667 377.333M184 378L184 379L250 379L229 378L184 378M381 383L381 386L382 386L381 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M397 383L398 384L397 383M398 384L399 385L398 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M399 385L400 386L399 385M400 386L401 387L400 386M306 387L306 390L307 390L306 387M320 387L320 392L321 392L320 387M383 388L384 389L383 388M128.333 389.667L128.667 390.333L128.333 389.667M384 389L385 390L384 389M114.333 390.667L114.667 391.333L114.333 390.667M385 390L386 391L385 390M305 391L306 392L305 391M386 391L387 392L386 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M404 391L405 392L404 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M129 392L130 393L129 392M405 392L406 393L405 392M304 393L305 394L304 393M319.333 393.667L319.667 394.333L319.333 393.667M406 393L407 394L406 393M115 394L116 395L115 394M303 394L304 395L303 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M407 394L408 395L407 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M302 395L303 396L302 395M389 395L390 396L389 395M133 396L134 397L133 396M301 396L302 397L301 396M318 396L319 397L318 396M390 396L391 397L390 396M116 397L117 398L116 397M299 397L300 398L299 397M391 397L392 398L391 397M137 398L137 399L140 399L137 398M295 398L295 399L298 399L295 398M317 398L318 399L317 398M392 398L393 399L392 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M410 398L411 399L410 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M117 399L118 400L117 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M411 399L412 400L411 399M118 400L119 401L118 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M316 400L317 401L316 400M412 400L413 401L412 400M413 401L414 402L413 401M120 403L121 404L120 403M314 403L315 404L314 403M396 403L397 404L396 403M121 404L122 405L121 404M313 404L314 405L313 404M397 404L398 405L397 404M122 405L123 406L122 405M312 405L313 406L312 405M398 405L399 406L398 405M123 406L124 407L123 406M311 406L312 407L311 406M399 406L400 407L399 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M417 406L418 407L417 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M418 407L419 408L418 407M126 408L127 409L126 408M308 408L309 409L308 408M419 408L420 409L419 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M128 409L129 410L128 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M306 409L307 410L306 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M420 409L421 410L420 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M130 410L131 411L130 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M304 410L305 411L304 410M402 410L403 411L402 410M132 411L133 412L132 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M133 411L134 412L133 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M301.667 411.333L302.333 411.667L301.667 411.333M403 411L404 412L403 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M136 412L137 413L136 412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M137 412L137 413L140 413L137 412M294 412L294 413L299 413L294 412M404 412L405 413L404 412M167 413L168 414L167 413M189 413L190 414L189 413M405 413L406 414L405 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M423 413L424 414L423 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M168 414L169 415L168 414M191 414L192 415L191 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M424 414L425 415L424 414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M169 415L170 416L169 415M425 415L426 416L425 415M170 416L171 417L170 416M194 416L195 417L194 416M426 416L427 417L426 416M196 417L197 418L196 417M198 418L199 419L198 418M409 418L410 419L409 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M174 419L175 420L174 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M200 419L201 420L200 419M410 419L411 420L410 419M175 420L176 421L175 420M202 420L203 421L202 420M411 420L412 421L411 420M204 421L205 422L204 421M412 421L413 422L412 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M430 421L431 422L430 421M178 422L179 423L178 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M207 422L208 423L207 422M431 422L432 423L431 422M179 423L180 424L179 423M209 423L210 424L209 423M432 423L433 424L432 423M212 424L213 425L212 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M433 424L434 425L433 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M182 425L183 426L182 425M215 425L216 426L215 425M415 425L416 426L415 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M184 426L185 427L184 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M218 426L219 427L218 426M416 426L417 427L416 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M185 427L186 428L185 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M221.667 427.333L222.333 427.667L221.667 427.333M417 427L418 428L417 427M187 428L188 429L187 428M225.667 428.333L226.333 428.667L225.667 428.333M418 428L419 429L418 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M436 428L437 429L436 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M189 429L190 430L189 429M229 429L229 430L232 430L229 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M437 429L438 430L437 429M191 430L192 431L191 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M235.667 430.333L236.333 430.667L235.667 430.333M438 430L439 431L438 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M193 431L194 432L193 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M241 431L241 432L244 432L241 431M439 431L440 432L439 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M195 432L196 433L195 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M248 432L248 433L254 433L248 432M197 433L198 434L197 433M258 433L259 434L258 433M422 433L423 434L422 433M199 434L200 435L199 434M259 434L260 435L259 434M423 434L424 435L423 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M201 435L202 436L201 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M202 435L203 436L202 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M260 435L261 436L260 435M424 435L425 436L424 435M204 436L205 437L204 436M261 436L262 437L261 436M425 436L426 437L425 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M443 436L444 437L443 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M207 437L208 438L207 437M444 437L445 438L444 437M210 438L211 439L210 438M445 438L446 439L445 438M213 439L214 440L213 439M263 439L264 440L263 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M446 439L447 440L446 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M216 440L217 441L216 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M217 440L218 441L217 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M264 440L265 441L264 440M428 440L429 441L428 440M220 441L221 442L220 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M221 441L222 442L221 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M429 441L430 442L429 441M224 442L225 443L224 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M225 442L226 443L225 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M265 442L266 443L265 442M430 442L431 443L430 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M228 443L229 444L228 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M229 443L230 444L229 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M230 443L231 444L230 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M266 443L267 444L266 443M431 443L432 444L431 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M449 443L450 444L449 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M233 444L234 445L233 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M234.667 444.333L235.333 444.667L234.667 444.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M450 444L451 445L450 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M240 445L241 446L240 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M241.667 445.333L242.333 445.667L241.667 445.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M243 445L244 446L243 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M451 445L452 446L451 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M248.667 446.333L249.333 446.667L248.667 446.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M250 446L251 447L250 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M251 446L252 447L251 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M268 446L269 447L268 446M452 446L453 447L452 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M252 447L253 448L252 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M269 447L270 448L269 447M435 448L436 449L435 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M253 449L254 450L253 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M270 449L271 450L270 449M436 449L437 450L436 449M254 450L255 451L254 450M271.333 450.667L271.667 451.333L271.333 450.667M437 450L438 451L437 450M455 450L456 451L455 450M438 451L439 452L438 451M256 453L257 454L256 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M257 454L258 455L257 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M271.333 455.667L271.667 456.333L271.333 455.667M441 455L442 456L441 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M455 455L456 456L455 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M258 456L259 457L258 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M442 456L443 457L442 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M455 456L456 457L455 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M259 457L260 458L259 457M443 457L444 458L443 457M454 457L455 458L454 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M260 458L261 459L260 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M444 458L445 459L444 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M453 458L454 459L453 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M261 459L262 460L261 459M268 459L269 460L268 459M445 459L446 460L445 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7bba55",
      stroke: "none"
    },
    d: "M451 459L452 460L451 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M452 459L453 460L452 459M264 460L265 461L264 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2a544",
      stroke: "none"
    },
    d: "M265 460L266 461L265 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7d03c",
      stroke: "none"
    },
    d: "M448.667 460.333L449.333 460.667L448.667 460.333z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt5);
export default __webpack_public_path__ + "static/media/rt5.93b13ca48b09fcadc7b4f8226575c363.svg";
export { ForwardRef as ReactComponent };